import { ChatConversation } from '@heroui-pro/react';
import { cn } from '@heroui/react';
import type { AiChatUiMessage } from '../types';
import { AiChatThreadMessage } from './AiChatThreadMessage';

export type AiChatMessageAreaProps = {
  className?: string;
  messages: AiChatUiMessage[];
  emptyHint?: string;
};

export function AiChatMessageArea({
  className,
  messages,
  emptyHint = '向 AI 发送消息开始对话',
}: AiChatMessageAreaProps) {
  return (
    <ChatConversation className={cn('min-h-0 flex-1', className)}>
      <ChatConversation.Content className="flex flex-col">
        <div className="mx-auto flex w-full max-w-[714px] flex-1 flex-col gap-8 px-4 pb-6 pt-8">
          {messages.length === 0 ? (
            <div className="text-muted flex flex-1 items-center justify-center text-sm">
              {emptyHint}
            </div>
          ) : (
            messages.map((message) => <AiChatThreadMessage key={message.id} message={message} />)
          )}
        </div>
        <ChatConversation.ScrollAnchor />
      </ChatConversation.Content>
    </ChatConversation>
  );
}
